import {
  FaPhoneAlt,
  FaEnvelope,
  FaWhatsapp,
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaYoutube,
  FaTiktok,
  FaMapMarkerAlt,
} from "react-icons/fa";
import SectionHeading from "./ui/SectionHeading";
import GradientButton from "./ui/GradientButton";

const socials = [
  { Icon: FaFacebook, href: "https://www.facebook.com/CMSTours92" },
  { Icon: FaInstagram, href: "https://www.instagram.com/cmstoursandtravels" },
  { Icon: FaYoutube, href: "https://www.youtube.com/@CMSToursandTravelsOfficial" },
  { Icon: FaTiktok, href: "https://www.tiktok.com/@visionbyahmadraza" },
  { Icon: FaLinkedin, href: "https://www.linkedin.com/company/chalomakkahshariftourstravelpvtltd/" },
];

const inputClass =
  "w-full rounded-lg border border-gray-200 px-4 py-2.5 text-sm outline-none transition focus:border-brand-green focus:ring-2 focus:ring-brand-green/30";

const Contact = () => {
  return (
    <section id="contact" className="section-pad bg-[#dfecd5]">
      <SectionHeading
        eyebrow="Get in Touch"
        title="Contact Us"
        subtitle="Have a question or ready to book? Reach out — we're here to help plan your journey."
      />
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-8 md:grid-cols-2">
        {/* Form */}
        <form className="space-y-5 rounded-2xl bg-white p-7 shadow-soft">
          <input type="text" placeholder="Your Name" className={inputClass} />
          <input type="email" placeholder="Your Email" className={inputClass} />
          <textarea placeholder="Your Message" className={`${inputClass} h-32 resize-none`} />
          <GradientButton variant="orange" type="submit">
            Send Message
          </GradientButton>
        </form>

        {/* Info */}
        <div className="flex flex-col justify-center space-y-6 rounded-2xl bg-white p-7 shadow-soft">
          <div>
            <h4 className="mb-3 text-lg font-semibold text-brand-dark">Our Offices</h4>
            <ul className="space-y-3">
              <li className="flex gap-2 text-gray-600">
                <FaMapMarkerAlt className="mt-1 shrink-0 text-brand-green" />
                <span>G-11, Hill View Arcade, 5 Davis Road, Shimla Hill, Lahore</span>
              </li>
              <li className="flex gap-2 text-gray-600">
                <FaMapMarkerAlt className="mt-1 shrink-0 text-brand-green" />
                <span>Office # 222, Old Eden Avenue, New Airport Road, Lhr Cantt.</span>
              </li>
              <li className="flex gap-2 text-gray-600">
                <FaMapMarkerAlt className="mt-1 shrink-0 text-brand-green" />
                <span>Street # 82, Jahangir Park, New Shad Bagh, Lahore</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-2 text-lg font-semibold text-brand-dark">Call Us</h4>
            <p className="flex items-center gap-2 text-gray-700">
              <FaPhoneAlt className="text-brand-green" />
              <a href="tel:+923151644222" className="hover:text-brand-green hover:underline">
                +92 315 1644222
              </a>
            </p>
            <p className="mt-1 flex items-center gap-2 text-gray-700">
              <FaWhatsapp className="text-brand-green" />
              <a
                href="https://wa.me/923151644222"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-brand-green hover:underline"
              >
                +92 315 1644222
              </a>
            </p>
          </div>

          <div>
            <h4 className="mb-2 text-lg font-semibold text-brand-dark">Email</h4>
            <a
              href="mailto:chalomakkah@gmail.com"
              className="flex items-center gap-2 text-gray-700 transition hover:text-brand-orange hover:underline"
            >
              <FaEnvelope className="text-brand-orange" />
              chalomakkah@gmail.com
            </a>
          </div>

          <div>
            <h4 className="mb-2 text-lg font-semibold text-brand-dark">Follow Us</h4>
            <div className="flex gap-4 text-2xl">
              {socials.map(({ Icon, href }) => (
                <a
                  key={href}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-brand-dark transition-colors hover:text-brand-gold"
                >
                  <Icon />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
